import React, { useEffect } from 'react';
import colors from '../../../Utils/colors';
import { AnnTemplateItem, SmsTemplateItem } from './NewComponents';
import { useSelector } from 'react-redux';
import images from '../../../Utils/images';
import CheerioButton from '../../../Components/CheerioButton';
import EmailTemplateCard from './EmailTemplateCard';
import RCSTemplateCard from './RCSTemplatesCard';

const AnnCompletion = ({
  shareTo,
  selectedTagsList,
  labelName,
  balance,
  item,
  variableList,
  templateV2Type,
  openCreateSmsModal,
  customSMSText,
  setWalletBalanceCheck,
}) => {
  const authtoken = useSelector((state) => state.main.auth_token);
  const localdata = useSelector((state) => state.main.localdata);

  const walletBalance = (localdata?.walletBalance || 0).toFixed(2);

  useEffect(() => {
    validateWalletBalance();
  }, [])

  const validateWalletBalance = () => {
    const totalCost = parseFloat(calculateTotalCost());
    const currentBalance = localdata?.walletBalance || 0;

    if (currentBalance <= 0) {
      setWalletBalanceCheck(false);
    } else if (totalCost <= currentBalance) {
      setWalletBalanceCheck(true);
    } else {
      setWalletBalanceCheck(false);
    }
  };

  const calculateTotalCost = () => {
    let contactCount = 0;
    let costPerMessage = 0;
    const isUSD = localdata?.walletCurrency !== 'INR';

    if (templateV2Type === "SMS Templates") {
      contactCount = balance?.mobileArr?.length || 0;
      costPerMessage = isUSD ? 0.0017 : 0.15;
    } else if (templateV2Type === "WhatsApp templates") {
      contactCount = balance?.mobileArr?.length || 0;
      if (item?.category === "UTILITY") {
        costPerMessage = isUSD ? 0.0023 : 0.2;
      } else {
        costPerMessage = isUSD ? 0.010 : 0.9;
      }
    } else if (templateV2Type === "RCS Templates") {
      contactCount = balance?.mobileArr?.length || 0;
      costPerMessage = isUSD ? 0.005 : 0.1;
    }

    const totalCost = contactCount * costPerMessage;
    return isUSD ? totalCost.toFixed(4) : totalCost.toFixed(2);
  };

  const mobileWidth = window.innerWidth < 900 ? true : false;

  return (
    <>
      <div
        className="d-flex flex-column justify-content-start align-items-start w-100 verythinscrollnew"
        style={{
          flex: 1,
          overflowY: 'scroll',
          paddingBlock: 20,
          paddingInline: mobileWidth ? 0 : 30,
        }}
      >
        <h4
          style={{
            padding: 0,
            margin: 0,
            fontSize: 16,
            fontWeight: 700,
            color: colors.black,
            marginBlock: 8,
          }}
        >
          {'Sharing to:'}
        </h4>
        {shareTo === 'Tags' ? (
          <>
            <div
              className="d-flex flex-row justify-content-start align-items-center"
              style={{ flexWrap: 'wrap', marginBlock: 16 }}
            >
              {selectedTagsList &&
                selectedTagsList.map((item) => {
                  return (
                    <>
                      <div
                        className="d-flex flex-row justify-content-center align-items-center"
                        key={`key${item?._id}`}
                        style={{
                          paddingBlock: 4,
                          paddingInline: 20,
                          border: `1px solid #FEAF52`,
                          borderRadius: 8,
                          marginInlineEnd: 16,
                          marginBlock: 6,
                        }}
                      >
                        <p
                          style={{
                            padding: 0,
                            margin: 0,
                            fontSize: 14,
                            fontWeight: 400,
                            color: '#FEAF52',
                          }}
                        >
                          {item?.tag_name}
                        </p>
                      </div>
                    </>
                  );
                })}
            </div>
          </>
        ) : (
          <>
            <div
              className="d-flex flex-row justify-content-center align-items-center"
              style={{
                paddingBlock: 4,
                paddingInline: 20,
                border: `1px solid #FEAF52`,
                borderRadius: 8,
                marginBlock: 16,
              }}
            >
              <p style={{ padding: 0, margin: 0, fontSize: 14, fontWeight: 400, color: '#FEAF52' }}>
                {labelName}
              </p>
            </div>
          </>
        )}

        <h4
          style={{
            padding: 0,
            margin: 0,
            fontSize: 16,
            fontWeight: 700,
            color: colors.black,
            marginBlock: 16,
          }}
        >
          {'Net required credits:'}
        </h4>
        <div
          className="d-flex flex-row justify-content-start align-items-center"
          style={{ width: '90%', marginBlockEnd: 16 }}
        >
          <div
            className="d-flex flex-row justify-content-between align-items-center"
            style={{ width: '30%', marginInlineEnd: 50 }}
          >
            <p
              style={{
                fontSize: 16,
                fontWeight: 400,
                color: colors.greys04,
                padding: 0,
                margin: 0,
              }}
            >
              {localdata?.walletCurrency && templateV2Type !== 'Email Templates' ? 'Required balance' : 'Required Conversations'}
            </p>
            <p
              style={{
                fontSize: 16,
                fontWeight: 400,
                color: colors.primary03,
                padding: 0,
                margin: 0,
              }}
            >
              {
                localdata?.walletCurrency && templateV2Type !== 'Email Templates'
                  ? `${localdata.walletCurrency !== 'INR' ? '$' : '₹'} ${calculateTotalCost()}`
                  : templateV2Type === 'Email Templates'
                    ? balance?.emailArr?.length ?? balance?.email_arr?.length ?? 0
                    : balance?.mobileArr?.length ?? balance?.mobile_arr?.length ?? 0
              }
            </p>
          </div>
          {localdata?.walletCurrency && templateV2Type !== 'Email Templates' ? (
            <div
              className="d-flex flex-row justify-content-between align-items-center"
              style={{ width: '50%' }}
            >
              <p
                style={{
                  fontSize: 16,
                  fontWeight: 400,
                  color: colors.greys04,
                  padding: 0,
                  margin: 0,
                }}
              >
                {'Available Balance'}
              </p>
              <p
                style={{
                  fontSize: 16,
                  fontWeight: 400,
                  color: colors.primary03,
                  padding: 0,
                  margin: 0,
                }}
              >
                {localdata?.walletCurrency !== 'INR' ? '$' : '₹'} {parseFloat(localdata?.walletBalance).toFixed(2)}
                <br />
                <span style={{ color: colors.error03 }}>
                  {parseFloat(walletBalance) < 0 || parseFloat(calculateTotalCost()) > parseFloat(walletBalance) ? 'Insufficient or low balance' : ''}
                </span>
              </p>
            </div>
          ) : (
            <div
              className="d-flex flex-row justify-content-between align-items-center"
              style={{ width: '50%' }}
            >
              <p
                style={{
                  fontSize: 16,
                  fontWeight: 400,
                  color: colors.greys04,
                  padding: 0,
                  margin: 0,
                }}
              >
                {'Available Conversations'}
              </p>
              <p
                style={{
                  fontSize: 16,
                  fontWeight: 400,
                  color: colors.primary03,
                  padding: 0,
                  margin: 0,
                }}
              >
                {templateV2Type == 'Email Templates' ? localdata?.balance?.email : localdata?.balance?.whatsapp}
                <br />
                <span style={{ color: colors.error03 }}>
                  {(templateV2Type == 'Email Templates' && balance?.emailArr?.length > localdata?.balance?.email) || (templateV2Type !== 'Email Templates' && balance?.mobileArr?.length > localdata?.balance?.whatsapp) ? 'Insufficient or low balance' : ''}
                </span>
              </p>
            </div>)}
        </div>

        <h4
          style={{
            padding: 0,
            margin: 0,
            fontSize: 16,
            fontWeight: 700,
            color: colors.black,
            marginBlock: 16,
          }}
        >
          {'Template used:'}
        </h4>
        {templateV2Type === 'SMS Templates' ? (
          <>
            {!openCreateSmsModal ?
              <SmsTemplateItem item={item?.templateData} onclickAction={() => { }} final={true} />
              : (
                <>
                  <div className="ann_template_v2_item_container" >
                    <div className="ann_template_v2_item">
                      <div className="ann_template_v2_item__row1">
                        <img src={images.CATemplate}></img>
                        <div className="text_container">
                          <p className="header_text">{"Custom SMS Template"}</p>
                          <p style={{
                            flexWrap: 'wrap',
                            whiteSpace: 'pre-wrap',
                          }}>
                            {`${customSMSText}`}
                          </p>
                        </div>
                      </div>

                      <div className="ann_template_v2_item__row2">
                        <CheerioButton
                          borderStyle={{ borderColor: colors.primary03, width: mobileWidth ? '100%' : '48%' }}
                          textStyle={{ fontSize: 12, fontWeight: 400, color: colors.white }}
                          btnText={'Use Template'}
                          backColor={colors.primary03}
                          disabled={true}
                        />
                      </div>
                    </div>
                  </div>
                </>
              )}
          </>
        ) : (
          templateV2Type === 'Email Templates' ? (
            <EmailTemplateCard
              template={item}
              showButton={false}
            />
          ) : templateV2Type === 'RCS Templates' ? (

            <RCSTemplateCard template={{
              _id: item?.name,
              templateName: item?.name,
              description: item?.textMessage,
              updatedAt: item?.lastUpdate,
              previewImage: item?.standaloneCard?.mediaUrl && !item?.standaloneCard?.mediaUrl.includes("mp4") ? item?.standaloneCard?.thumbnailUrl : item?.carouselCard?.[0]?.mediaUrl && !item?.carouselCard?.[0]?.mediaUrl.includes("mp4") ? item?.carouselCard?.[0]?.thumbnailUrl : null,
              status: item?.status,
            }} onClick={() => { }} showButton={false} />
          ) : (
            <AnnTemplateItem item={item} onclickAction={() => { }} final={true} />
          )
        )}
        <h4
          style={{
            padding: 0,
            margin: 0,
            fontSize: 16,
            fontWeight: 700,
            color: colors.black,
            marginBlockStart: 30,
            marginBlockEnd: 8,
          }}
        >
          {'Offer details:'}
        </h4>
        {variableList &&
          variableList.map((item, index) => {
            return (
              <>
                <p
                  key={index}
                  style={{
                    padding: 0,
                    margin: 0,
                    marginBlock: 2,
                    fontSize: 16,
                    fontWeight: 600,
                    color: colors.black,
                  }}
                >
                  {`Variable ${index + 1}: `}
                  <span style={{ fontWeight: 400 }}>{item}</span>
                </p>
              </>
            );
          })}
      </div>
    </>
  );
};

export default AnnCompletion;
